


























import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import userInterface from '../interface/user';
import Btn from '../Button/Btn.vue';
import taskInterface from '../interface/taskInterface';
import playSound from '../../utils/sounds/index';

@Component({
  computed: {
    ...mapGetters(['getUsers', 'getCurrentName']),
  },
  components: {
    Btn,
  },
})
export default class Prepare extends Vue {
  @Prop({ default: 0 }) private timer!: number;

  @Prop({ default: Array }) private pickedRoutes!: taskInterface[];

  currentTimer = this.timer || 0;

  getUsers!: userInterface[];

  getCurrentName!: string;

  discard: taskInterface[] = [];

  playSound = playSound;

  prepareTimer = setInterval(() => {
    this.currentTimer -= 0.1;
    if (this.currentTimer <= 0.1) {
      this.acceptDiscard();
    }
  }, 100);

  get checkPickRoute(): boolean {
    return this.pickedRoutes.length > 0;
  }

  get currentUser(): userInterface {
    return this.getUsers.filter((user) => user.name === this.getCurrentName)[0];
  }

  get currentTasks(): taskInterface[] | undefined {
    return this.checkPickRoute ? this.pickedRoutes : this.currentUser?.hand.currentTasks;
  }

  get cards(): Record<string, number> {
    return this.currentUser.hand.cards;
  }

  acceptDiscard(): void {
    if (this.prepareTimer) clearInterval(this.prepareTimer);
    if (this.checkPickRoute) {
      this.$socket.emit('addShortRoute', this.getCurrentName, this.pickedRoutes);
      this.$emit('get-discarded', this.discard);
    } else {
      this.$emit('get-discarded', this.discard);
    }
    this.$emit('close-modal');
  }

  markToDiscard(e: MouseEvent, task: taskInterface): void {
    if (e.target instanceof Element) {
      const { target } = e;
      const length = target.parentNode?.children.length || 0;
      let numOfDiscard: number;
      if (length <= 3) {
        numOfDiscard = length - 1;
      } else {
        numOfDiscard = 2;
      }
      if (target.classList.contains('discard')) {
        target.classList.remove('discard');
        if (target.classList.contains('route__long')) {
          const index = this.discard.indexOf(task);
          this.discard.splice(index, 1);
        } else {
          const index = this.discard.indexOf(task);
          this.discard.splice(index, 1);
        }
      } else if (this.discard.length < numOfDiscard) {
        target.classList.add('discard');
        if (target.classList.contains('route__long')) {
          this.discard.push(task);
        } else {
          this.discard.push(task);
        }
      }
    }
  }

  showRouteInfo(cities: string[]): void {
    this.$emit('showCities', cities);
  }

  hideRouteInfo(): void {
    this.$emit('hideCities');
  }

  takeCardPlaySound(): void {
    this.playSound('takeCard');
  }
}
